import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, withCtx as _withCtx, normalizeClass as _normalizeClass, Transition as _Transition } from "vue"

const _hoisted_1 = { class: "flex items-center gap-2" }
const _hoisted_2 = { class: "font-extrabold text-gray-900 text-2xl md:text-3xl" }
const _hoisted_3 = {
  key: 0,
  class: "bg-green-300 text-white text-xs px-1 py-0.5 rounded"
}
const _hoisted_4 = { class: "flex flex-row items-center justify-end gap-4" }
const _hoisted_5 = { class: "py-1 divide-y" }
const _hoisted_6 = { class: "ml-2" }
const _hoisted_7 = ["checked"]
const _hoisted_8 = ["checked"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", null, " Admin Mode ", -1)

import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/vue";
import { EllipsisVerticalIcon } from "@heroicons/vue/24/outline";
import { PlusIcon } from "@heroicons/vue/24/solid";
import LoadingSpinner from "shared/components/loading_state/LoadingSpinner.vue";
import MainButton from "@/components/other/MainButton.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'UnitValuesEditorHeader',
  props: {
  approved: {
    type: Boolean,
    required: false,
  },
  isSubmitting: {
    type: Boolean,
    required: false,
  },
  isSubmitDisabled: {
    type: Boolean,
    required: false,
  },
  isAdminMode: {
    type: Boolean,
    required: false,
  },
},
  emits: ["addTypeClicked", "excelExportClicked", "toggleApproveClicked", "toggleAdminMode"],
  setup(__props) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["flex flex-col md:flex-row justify-between md:px-6 px-4 py-5 gap-2", { 'bg-yellow-200': __props.isAdminMode }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t("unit_values.header")), 1),
      (__props.isAdminMode && __props.approved)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.$t("unit_values.approved").toLowerCase()), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("button", {
        type: "button",
        class: "md:text-sm text-xs focus:outline-none whitespace-nowrap inline-flex gap-1 items-center rounded-md border border-transparent shadow-sm px-2 py-2 bg-green-300 hover:bg-green-400 focus:ring-0 text-white",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('addTypeClicked')))
      }, [
        _createVNode(_unref(PlusIcon), { class: "w-4 h-4 md:w-6 md:h-5" }),
        _createTextVNode(" " + _toDisplayString(_ctx.$t("unit_values.add_type")), 1)
      ]),
      _createVNode(MainButton, {
        label: _ctx.$t('buttons.save'),
        type: "submit",
        color: "yellow",
        isDisabled: __props.isSubmitDisabled,
        style: {"margin-top":"0"}
      }, {
        default: _withCtx(() => [
          (__props.isSubmitting)
            ? (_openBlock(), _createBlock(LoadingSpinner, {
                key: 0,
                size: "w-5 h-5",
                color: "white",
                class: "mr-2"
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["label", "isDisabled"]),
      _createVNode(_unref(Menu), {
        as: "div",
        class: "inline-block text-left leading-none",
        style: {"z-index":"999999"}
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(MenuButton), { class: "flex items-center rounded-full text-gray-500 hover:text-gray-600" }, {
            default: _withCtx(() => [
              _createVNode(_unref(EllipsisVerticalIcon), {
                class: "h-8 w-8",
                "aria-hidden": "true"
              })
            ]),
            _: 1
          }),
          _createVNode(_Transition, {
            "enter-active-class": "transition ease-out duration-100",
            "enter-from-class": "transform opacity-0 scale-95",
            "enter-to-class": "transform opacity-100 scale-100",
            "leave-active-class": "transition ease-in duration-75",
            "leave-from-class": "transform opacity-100 scale-100",
            "leave-to-class": "transform opacity-0 scale-95"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(MenuItems), { class: "absolute right-5 z-10 mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-gray/5 focus:outline-none" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_5, [
                    _createVNode(_unref(MenuItem), {
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('excelExportClicked')))
                    }, {
                      default: _withCtx(({ active }) => [
                        _createElementVNode("a", {
                          href: "#",
                          class: _normalizeClass([
                    active ? 'bg-gray-100 text-gray-900' : 'text-gray-700',
                    'group flex items-center px-4 py-2 text-sm',
                  ])
                        }, [
                          _createVNode(_unref(FontAwesomeIcon), {
                            icon: "fa-solid fa-file-excel",
                            class: "h-4 text-green"
                          }),
                          _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t("unit_values.export_to_excel")), 1)
                        ], 2)
                      ]),
                      _: 1
                    }),
                    (__props.isAdminMode)
                      ? (_openBlock(), _createBlock(_unref(MenuItem), { key: 0 }, {
                          default: _withCtx(({ active }) => [
                            _createElementVNode("button", {
                              type: "button",
                              class: _normalizeClass(["flex w-full items-center px-4 py-2 text-sm", [active ? 'bg-gray-100 text-gray-900' : 'text-gray-700']]),
                              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('toggleApproveClicked')))
                            }, [
                              _createElementVNode("input", {
                                type: "checkbox",
                                checked: __props.approved,
                                class: "h-4 w-4 rounded border-gray-300 text-orange-400 focus:bg-gray-50 pointer-events-none mr-2"
                              }, null, 8, _hoisted_7),
                              _createElementVNode("span", null, _toDisplayString(_ctx.$t("unit_values.approved")), 1)
                            ], 2)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.hasPermission('app_admin'))
                      ? (_openBlock(), _createBlock(_unref(MenuItem), { key: 1 }, {
                          default: _withCtx(({ active }) => [
                            _createElementVNode("button", {
                              type: "button",
                              class: _normalizeClass(["flex w-full items-center px-4 py-2 text-sm", [active ? 'bg-gray-100 text-gray-900' : 'text-gray-700']]),
                              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('toggleAdminMode')))
                            }, [
                              _createElementVNode("input", {
                                type: "checkbox",
                                checked: __props.isAdminMode,
                                class: "h-4 w-4 rounded border-gray-300 text-orange-400 focus:bg-gray-50 pointer-events-none mr-2"
                              }, null, 8, _hoisted_8),
                              _hoisted_9
                            ], 2)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ])
  ], 2))
}
}

})